import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import { SupplierRegister } from "./Supplier";

import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutlineOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { SupplierAddress } from "./SupplierAddress";
import { SupplierEmail } from "./SupplierEmail";
import { SupplierPhone } from "./SupplierPhone";

/**
 * Author : AndréK
 * 26/08/2022
*/
const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const SupplierControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="supplier tab"
                >
                    <CustomTabStyle
                        label={t("supplier")}
                        {...a11yProps(0)}
                        icon={<SearchIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("address")}
                        {...a11yProps(1)}
                        disabled={id === 0}
                        icon={<HomeOutlinedIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("email")}
                        {...a11yProps(2)}
                        disabled={id === 0}
                        icon={<MailOutlineIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("phone")}
                        {...a11yProps(3)}
                        disabled={id === 0}
                        icon={<CallOutlinedIcon fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <SupplierRegister updateId={dispatch} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <SupplierAddress idSupplier={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <SupplierEmail idSupplier={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <SupplierPhone idSupplier={id} />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default SupplierControl;